import styled from 'styled-components'
import Fonts from '../../theme/fonts'
import Colors from '../../theme/colors'

const styles = styled.div<{disabled: boolean}>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  line-height: 24px;
  font-family: ${Fonts.fontFamilies.Inter};
  font-size: ${Fonts.fontSizes.p16};

  * {
    user-select: none;
  }

  input {
    background: none !important;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    box-shadow: 0 4px 6px rgb(181 181 181 / 28%);
    width: 100%;
    background: white;
    z-index: 1;

    li {
      padding: 10px;
      cursor: pointer;

      &[data-selected='true'] {
        background-color: #f5f5f5;
      }

      &:hover {
        background-color: #f5f5f5;
      }
    }
  }

  .highlighted {
    font-weight: bold;
  }

  &:disabled {
    color: ${Colors.Primary.GreyTextLight};
    background: ${Colors.Primary.GreyLight};
    border: 1px solid ${Colors.Primary.Grey};
  }

  svg.selection-icon {
    margin-left: -32px;

    path {
      fill: ${Colors.Primary.GreyDark};
    }

    &.valid {
      path {
        fill: ${Colors.Action.SuccessGreen};
      }
    }

    &.invalid {
      path {
        fill: ${Colors.Action.ErrorRed};
      }
    }

    &:hover {
      cursor: pointer;
    }
  }

`

export default styles
